<template>
  <header class="app-header" :class="{ 'header-scrolled': scrolled }">
    <div class="header-inner">
      <router-link to="/" class="header-logo" aria-label="Digitly home">
        <span class="logo-text">digitly</span>
      </router-link>

      <nav class="header-nav d-none d-md-flex" aria-label="Main navigation">
        <router-link
          v-for="link in navLinks"
          :key="link.name"
          :to="link.path"
          class="nav-link"
          :class="{ 'nav-link-active': $route.path === link.path }"
        >
          {{ link.name }}
        </router-link>
      </nav>

      <div class="header-actions d-none d-md-flex">
        <router-link to="/contact" class="header-cta">
          Get in touch
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </router-link>
      </div>

      <button
        class="mobile-toggle d-md-none"
        @click="drawer = !drawer"
        :aria-expanded="drawer"
        aria-label="Toggle navigation menu"
      >
        <span class="toggle-line" :class="{ 'open': drawer }"></span>
        <span class="toggle-line" :class="{ 'open': drawer }"></span>
      </button>
    </div>

    <transition name="slide-down">
      <div v-if="drawer" class="mobile-menu d-md-none">
        <nav class="mobile-nav" aria-label="Mobile navigation">
          <router-link
            v-for="link in [...navLinks, { name: 'Contact', path: '/contact' }]"
            :key="link.name"
            :to="link.path"
            class="mobile-link"
            @click="drawer = false"
          >
            {{ link.name }}
          </router-link>
        </nav>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: 'AppBar',
  data() {
    return {
      drawer: false,
      scrolled: false,
      navLinks: [
        { name: 'Home', path: '/' },
        { name: 'Services', path: '/services' },
        { name: 'About', path: '/about' },
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 10
    }
  }
}
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  transition: box-shadow 0.3s ease;
}

.header-scrolled {
  box-shadow: 0 1px 0 0 var(--color-border);
}

.header-inner {
  max-width: var(--container-max);
  margin: 0 auto;
  padding: 0 24px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-logo {
  text-decoration: none;
  display: flex;
  align-items: center;
}

.logo-text {
  font-size: 1.375rem;
  font-weight: 800;
  color: var(--color-text);
  letter-spacing: -0.04em;
}

.header-nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-link {
  font-size: 0.9375rem;
  font-weight: 500;
  color: var(--color-text-secondary);
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 980px;
  transition: color 0.2s ease, background 0.2s ease;
}

.nav-link:hover {
  color: var(--color-text);
}

.nav-link-active {
  color: var(--color-text);
}

.header-actions {
  display: flex;
  align-items: center;
}

.header-cta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 10px 20px;
  background: var(--color-accent);
  color: #FFFFFF;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: var(--font-family);
  border-radius: 980px;
  text-decoration: none;
  transition: background 0.2s ease;
}

.header-cta:hover {
  background: #333336;
}

.mobile-toggle {
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.toggle-line {
  display: block;
  width: 20px;
  height: 1.5px;
  background: var(--color-text);
  border-radius: 2px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.toggle-line.open:first-child {
  transform: translateY(3.75px) rotate(45deg);
}

.toggle-line.open:last-child {
  transform: translateY(-3.75px) rotate(-45deg);
}

.mobile-menu {
  background: var(--color-bg);
  border-top: 1px solid var(--color-border);
  padding: 24px;
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-link {
  font-size: 1.125rem;
  font-weight: 500;
  color: var(--color-text);
  text-decoration: none;
  padding: 12px 0;
  border-bottom: 1px solid var(--color-border);
}

.mobile-link:last-child {
  border-bottom: none;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
